module.exports = __webpack_public_path__ + "static/media/contrato_icon.d3dd2223.png";